import angular from 'angular';

export default function EditPreparationItemCategoryDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  amDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSavePreparationItemCategory = _handleSavePreparationItemCategory;
  vm.IsValidControl = _IsValidControl;
  vm.contentPaneIsFaded = false;
  vm.currentPreparationItemCategoryId = 0;
  vm.newPreparationItemCategory = { ...vm.preparationItemCategory };

  _activate();

  // //////// METHODS //////////

  function _activate() {
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleSavePreparationItemCategory() {
    _savePreparationItemCategory();
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.editPreparationItemCategoryDialog);
  }

  function _savePreparationItemCategory() {
    const dfdSave = $q.defer();

    if ($scope.editAMPreparationItemCategoryForm.$valid) {
      amDataService.savePreparationItemCategory(vm.newPreparationItemCategory).then((response) => {
        if (response.data.result) {
          alerts.error('Error occurred while saving the Preparation Item Category.');
        } else {
          const savedPreparationItemCategory = response.data;
          const isNew = vm.newPreparationItemCategory.preparationItemCategoryId <= 0;

          angular.extend(vm.newPreparationItemCategory, savedPreparationItemCategory);
          angular.extend(vm.preparationItemCategory, vm.newPreparationItemCategory);

          alerts.success('The Preparation Item Category has been saved successfully.');

          if (isNew) {
            $rootScope.$broadcast('refreshAMPreparationItemCategories',
              { auditId: vm.newPreparationItemCategory.auditId });
          } else {
            $rootScope.$broadcast('refreshAMPreparationItemCategory',
              { preparationItemCategoryId: vm.newPreparationItemCategory.preparationItemCategoryId });
          }

          ssDialogService.hide(ssDialogService.dialogs.auditTrail.editPreparationItemCategoryDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }

  // function _refresh() {
  //   vm.isProcessingComplete = false;
  //   const dfdRefresh = $q.defer();
  //   if (vm.newPreparationItemCategory && null !== vm.newPreparationItemCategory) {
  //     vm.currentPreparationItemCategoryId = vm.newPreparationItemCategory.preparationItemCategoryId;
  //   }
  //
  //   vm.isProcessingComplete = true;
  //   dfdRefresh.resolve();
  //   return dfdRefresh.promise;
  // }

  // validation
  function _IsValidControl(ctrl) {
    return ($scope.editAMPreparationItemCategoryForm)
      && (($scope.editAMPreparationItemCategoryForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }
}

EditPreparationItemCategoryDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'amDataService'
];
